<template></template>
<script>
export default {
  mounted () {
    this.$nextTick(() => {
      this.setFilterRanges()
    })
  },

  methods: {
    setFilterRanges () {
      const builder = this.$route.query.builder ? this.$route.query.builder : ''
      const livingOptionsDwellings = this.$store.getters['property/livingOptionsDwellings']

      const sizeRanges = this.$store.getters['filter/dwellingSizeRanges']
      const priceRanges = this.$store.getters['filter/priceRanges']
      
      if (livingOptionsDwellings.length) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputPriceRange: priceRanges,
          inputDwellingSizeRange: sizeRanges,
          inputBeds: false,
          inputBaths: false,
          inputCars: false,
          inputLotNumber: '',
          inputBuilder: builder
        })
      }
    },
  }
}
</script>
